<template>
    <!-- Main Wrapper -->
        <div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Sidebar -->
                <layout-sidebar />
			<!-- /Sidebar -->
			
			<!-- Page Wrapper -->
            <div class="page-wrapper">
			
				<!-- Page Content -->
                <div class="content container-fluid">
					
				
					<!-- Page Header -->
					<div class="page-header">
						<div class="row">
							<div class="col">
								<h3 class="page-title">Daily Report</h3>
								<ul class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Dashboard</router-link></li>
									<li class="breadcrumb-item active">Daily Report</li>
								</ul>
							</div>
							<div class="col-auto">
								<a href="#" class="btn btn-primary">PDF</a>
							</div>
						</div>
					</div>
					<!-- /Page Header -->
					
						<!-- Content Starts -->
						<div class="row justify-content-center">
							<div class="col-md-3 col-sm-6">
								<div class="card">
									<div class="card-body text-center">
										<h3><b>101</b></h3>
										<p>Total Employees</p>
									</div>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<div class="card">
									<div class="card-body text-center">
										<h3 class="text-success"><b>84</b></h3>
										<p>Today Present</p>
									</div>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<div class="card">
									<div class="card-body text-center">
										<h3 class="text-danger"><b>12</b></h3>
										<p>Today Absent</p>
									</div>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<div class="card">
									<div class="card-body text-center">
										<h3><b>5</b></h3>
										<p>Today Left</p>
									</div>
								</div>
							</div>
						</div>
							<!-- Search Filter -->
					<div class="row filter-row mb-4">
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus">
								<input class="form-control floating" type="text">
								<label class="focus-label">Employee</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3"> 
							<div class="form-group form-focus select-focus">
								<select class="select floating"> 
									<option>Select Department</option>
									<option>Designing</option>
									<option>Development</option>
									<option>Finance</option>
									<option>Hr & Finance</option>
								</select>
								<label class="focus-label">Department</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus">
								<div class="cal-icon">
									<input class="form-control floating datetimepicker" type="text">
								</div>
								<label class="focus-label">From</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus">
								<div class="cal-icon">
									<input class="form-control floating datetimepicker" type="text">
								</div>
								<label class="focus-label">To</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<a href="#" class="btn btn-success btn-block"> Search </a>  
						</div>     
                    </div>
					<!-- /Search Filter -->
					<div class="row">
						<div class="col-md-12">
							<div class="table-responsive">
								<table class="table table-striped custom-table mb-0 datatable">
									<thead>
										<tr>
											<th>Employee</th>
											<th>Date</th>
											<th>Department</th>
											<th class="text-center">Status</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<h2 class="table-avatar">
													<router-link to="/profile" class="avatar"><img alt="" src="@/assets/profiles/avatar-02.jpg"></router-link>
													<router-link to="/profile">John Doe <span>#0001</span></router-link>
												</h2>
											</td>
											<td>20 Dec 2020</td>
											<td>Design</td>
											<td class="text-center">
												<button class="btn btn-outline-info btn-sm">Week off</button>
											</td>
										</tr>
										<tr>
											<td>
												<h2 class="table-avatar">
													<router-link to="/profile" class="avatar"><img alt="" src="@/assets/profiles/avatar-09.jpg"></router-link>
													<router-link to="/profile">Richard Miles <span>#0002</span></router-link>
												</h2>
											</td>
											<td>20 Dec 2020</td>
											<td>Web Developer</td>
											<td class="text-center">
												<button class="btn btn-outline-danger btn-sm">Absent</button>
											</td>
										</tr>
										<tr>
											<td>
												<h2 class="table-avatar">
													<router-link to="/profile" class="avatar"><img alt="" src="@/assets/profiles/avatar-10.jpg"></router-link>
													<router-link to="/profile">John Smith <span>#003</span></router-link>
												</h2>
											</td>
											<td>20 Dec 2020</td>
											<td>Android Developer</td>
											<td class="text-center">
												<button class="btn btn-outline-info btn-sm">Week off</button>
											</td>
										</tr>
										<tr>
											<td>
												<h2 class="table-avatar">
													<router-link to="/profile" class="avatar"><img alt="" src="@/assets/profiles/avatar-05.jpg"></router-link>
													<router-link to="/profile">Mike Litorus <span>#004</span></router-link>
												</h2>
											</td>
											<td>20 Dec 2020</td>
											<td>IOS Developer</td>
											<td class="text-center">
												<button class="btn btn-outline-info btn-sm">Week off</button>
											</td>
										</tr>
										<tr>
											<td>
												<h2 class="table-avatar">
													<router-link to="/profile" class="avatar"><img alt="" src="@/assets/profiles/avatar-11.jpg"></router-link>
													<router-link to="/profile">Wilmer Deluna <span>#005</span></router-link>
												</h2>
											</td>
											<td>20 Dec 2020</td>
											<td>Team Leader</td>
											<td class="text-center">
												<button class="btn btn-outline-info btn-sm">Week off</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					
                
					<!-- /Content End -->
					
                </div>
				<!-- /Page Content -->
				
            </div>
			<!-- /Page Wrapper -->

        </div>
		<!-- /Main Wrapper -->
</template>


<script>
    export default {
        mounted() {
             if ($('.datetimepicker').length > 0) {
                $('.datetimepicker').datetimepicker({
                    format: 'DD/MM/YYYY',
                    icons: {
                        up: "fa fa-angle-up",
                        down: "fa fa-angle-down",
                        next: 'fa fa-angle-right',
                        previous: 'fa fa-angle-left'
                    }
                });
            }

            if ($('.datatable').length > 0) {
                $('.datatable').DataTable({
                "bFilter": false,
                });
            }
            // Select 2
            if ($('.select').length > 0) {
                $('.select').select2({
                    minimumResultsForSearch: -1,
                    width: '100%'
                });
            }
        },
        name: 'payslipreports'
    }
</script>


// WEBPACK FOOTER //
// src/components/dailyreports.vue